import { render, staticRenderFns } from "./ContentHtml.vue?vue&type=template&id=5bb86623&scoped=true&"
import script from "./ContentHtml.vue?vue&type=script&lang=js&"
export * from "./ContentHtml.vue?vue&type=script&lang=js&"
import style0 from "./ContentHtml.vue?vue&type=style&index=0&id=5bb86623&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb86623",
  null
  
)

export default component.exports